import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";

export class PartnerConnectIsHistory extends Decision {
    public evaluate(): Exit {
        return (PartnerConnectManager.isHistoryMode()) ? Exit.True : Exit.False;
    }
}
